import { render, staticRenderFns } from "./newtask.vue?vue&type=template&id=7f557bce&scoped=true&"
import script from "./newtask.vue?vue&type=script&lang=js&"
export * from "./newtask.vue?vue&type=script&lang=js&"
import style0 from "./newtask.vue?vue&type=style&index=0&id=7f557bce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f557bce",
  null
  
)

export default component.exports